// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { max as fn } from "../max.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const max = convertToFP(fn, 1);

// Fallback for modularized imports:
export default max;
